var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rating)?_c('div',{staticClass:"c-player__age-rating o-typography__headline3"},[_vm._v(" "+_vm._s(_vm.rating)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }